import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { PayoutTermRewardType, PayoutTermType } from 'src/modules/conversions/infra/dtos';

export enum ProjectSetupStep {
  ProjectTriggers = '1',
  ProjectRewardType = '2',
  ProjectRewards = '3',
}

interface ISetupFormContext {
  programType: PayoutTermType | undefined;
  setProgramType: React.Dispatch<React.SetStateAction<PayoutTermType | undefined>>;
  rewardType: PayoutTermRewardType | undefined;
  setRewardType: React.Dispatch<React.SetStateAction<PayoutTermRewardType | undefined>>;
  isPoints: boolean;
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  prevStep: () => void;
  nextStep: () => void;
}

export const SetupContext = createContext<ISetupFormContext>({} as ISetupFormContext);

////////////////////////////////////////////////

interface ISetupFormProvider {
  children: React.ReactNode;
  stepsNumber?: number;
}

export const SetupFormProvider = ({ children, stepsNumber = 0 }: ISetupFormProvider) => {
  const [programType, setProgramType] = useState<PayoutTermType>();
  const [rewardType, setRewardType] = useState<PayoutTermRewardType>();

  const [currentStep, setCurrentStep] = useState(1);

  const [isPoints, setIsPoints] = useState(false);
  useEffect(() => {
    setIsPoints(Boolean(programType == PayoutTermType.Point));
  }, [programType]);

  const prevStep = useCallback(() => {
    setCurrentStep((prev) => {
      const newStep = prev - 1;
      return newStep >= 1 ? newStep : prev;
    });
  }, []);

  const nextStep = useCallback(() => {
    setCurrentStep((prev) => {
      const newStep = prev + 1;
      return newStep <= stepsNumber ? newStep : prev;
    });
  }, [stepsNumber]);

  return (
    <SetupContext.Provider
      value={{
        programType,
        setProgramType,
        rewardType,
        setRewardType,
        isPoints,
        currentStep,
        setCurrentStep,
        prevStep,
        nextStep,
      }}
    >
      {children}
    </SetupContext.Provider>
  );
};

export const useSetupFormContext = (): ISetupFormContext => useContext(SetupContext);
